function tryNowElementsVisibility(){
    const header = document.querySelector('header')
    const tryNowURLs = document.querySelectorAll('.trynow-url')
    
    if(header && window.innerWidth > 989){
        header.style.gridTemplateColumns = 'auto auto 1fr';
    }

    tryNowURLs.forEach(url => {
        url.classList.remove('trynow-hidden')
    })
}

window.addEventListener('trynow:initialized', function(){
    if(!window.trynow) return
    tryNowElementsVisibility()
})

window.addEventListener('load', function(){
    if(!window.trynow) return
    tryNowElementsVisibility()
})

let tryNowSellingPlan

window.addEventListener('load', async function(){
    if(!window.trynow) return
    tryNowSellingPlan = (await window.trynow.getSellingPlanId()).split('/').pop()

    const tryNowButton = document.querySelector('#trynow-cta-button')
    if(tryNowButton){
        tryNowButton.addEventListener('click', function(){
            window.tryNowButtonClicked = true
            const kachingBundle = document.querySelector('kaching-bundles-block')

            if(kachingBundle){
                kachingBundle.setAttribute("selling-plan-id", tryNowSellingPlan);
            }
        }, true)
    }
})

document.addEventListener('DOMContentLoaded', function(){
    const addToCartButton = document.querySelector('.product-form__submit')

    if(!addToCartButton) return;
    
    addToCartButton.addEventListener('click', function(){
        const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]')
        const kachingBundle = document.querySelector('kaching-bundles-block')

        if(window.tryNowButtonClicked){
            sellingPlanInputs.forEach(input => {
                input.value = tryNowSellingPlan
            })
            
            setTimeout(function(){
                sellingPlanInputs.forEach(input => {
                    input.value = ""
                })
                if(kachingBundle){
                    kachingBundle.setAttribute("selling-plan-id", '');
                }
                window.tryNowButtonClicked = false
            },3000)
        }
    })
})